// Mock data for Agencia PPC website - Marketing Agency

// Images - Hosted locally to avoid Google Ads policy issues
export const images = {
  founderPhoto: '/images/founder.png',
  googleAdsLogo: '/images/google-ads-logo.png',
  googleAdsCertified: '/images/google-ads-certified.webp',
  agencyLogo: '/images/logo.png',
  illustration: '/images/illustration.png',
  heroIllustration: '/images/illustration.png',
  servicesIllustration: '/images/services.png',
  complianceIllustration: '/images/compliance.png',
  webCreationIllustration: '/images/web-creation.png',
  digitalMarketing: '/images/services.png',
  analytics: '/images/illustration.png',
  teamWork: '/images/services.png',
  dashboard: '/images/compliance.png',
  growth: '/images/web-creation.png',
};

// Contact info - Spanish (default)
export const contactInfo = {
  email: 'ulysse@agencia-ppc.es',
  whatsapp: '34613076099',
  phone: '+34 613 076 099',
  linkedin: 'https://www.linkedin.com/in/ulysseberneau/',
};

// Contact info by language
export const contactByLanguage = {
  es: {
    whatsapp: '34613076099',
    phone: '+34 613 076 099',
    location: 'Barcelona, España',
  },
  fr: {
    whatsapp: '33633041764',
    phone: '+33 6 33 04 17 64',
    location: 'Paris, France & Barcelona, España',
  },
  en: {
    whatsapp: '33633041764',
    phone: '+33 6 33 04 17 64',
    location: 'Paris, France & Barcelona, Spain',
  },
};

// Default whatsapp/phone (Spanish)
export const whatsappNumber = '34613076099';
export const phoneNumber = '+34 613 076 099';

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      compliance: 'Compliance Google Ads',
      webCreation: 'Creación Web',
      contact: 'Contacto',
    },
    hero: {
      badge: 'Agencia de Marketing Digital Google Ads',
      title: 'Somos una agencia digital especializada en Google Ads',
      subtitle: 'Somos una agencia de marketing digital especializada en Google Ads y generación de leads. Campañas optimizadas, seguimiento de conversiones y compliance para maximizar tu ROI.',
      cta: 'Solicitar auditoría gratuita',
      ctaCompliance: '¿Cuenta Google Ads suspendida?',
      ctaSecondary: 'WhatsApp',
      ctaCall: 'Llamar',
    },
    kpis: {
      title: 'Resultados desde 2022',
      spent: { value: '6M€', label: 'invertidos en Google Ads' },
      calls: { value: '1.5M', label: 'llamadas entrantes generadas' },
      roi: { value: '>1.7', label: 'ROI medio' },
      since: { value: '2022', label: 'años de experiencia' },
    },
    mission: {
      title: 'Agencia de Marketing Digital Especializada en Google Ads',
      text: 'Ayudamos a empresas a generar más clientes a través de campañas Google Ads optimizadas, landing pages de alta conversión y un tracking impecable. Desde la estrategia hasta la ejecución, maximizamos tu retorno de inversión.',
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones completas de marketing digital para hacer crecer tu negocio',
      items: [
        {
          id: 'campaigns',
          title: 'Creación y Optimización de Campañas',
          description: 'Campañas Google Ads a medida para tu negocio: Search, Display, Performance Max, Demand Gen y remarketing avanzado.',
          features: ['Campañas Search & Display', 'Performance Max', 'Estrategias de puja avanzadas', 'Optimización continua'],
        },
        {
          id: 'leads',
          title: 'Generación y Venta de Leads',
          description: 'Captamos leads cualificados para tu empresa: formularios, llamadas entrantes y conversiones medibles.',
          features: ['Formularios optimizados', 'Call Ads y llamadas entrantes', 'Leads cualificados', 'Pago por resultado'],
        },
        {
          id: 'compliance',
          title: 'Compliance Google Ads',
          description: 'Expertos en desbloquear cuentas suspendidas y hacer apelaciones: Business Operations Verification (BOV), Unacceptable Business Practices y más.',
          features: ['Desbloqueo de cuentas', 'Apelaciones BOV', 'Unacceptable Business Practices', 'Verificación de anunciante'],
        },
        {
          id: 'web',
          title: 'Creación de Sitios Web',
          description: 'Diseño y desarrollo de landing pages y sitios web optimizados para conversión, rápidos y mobile-first.',
          features: ['Landing pages de alta conversión', 'Diseño responsive', 'Optimización de velocidad', 'UX orientada a conversión'],
        },
        {
          id: 'tracking',
          title: 'Tracking e Implementación de Conversiones',
          description: 'Configuración completa de Google Tag Manager, seguimiento de conversiones, analytics y reporting detallado.',
          features: ['Google Tag Manager', 'Tracking de conversiones', 'Google Analytics 4', 'Reporting personalizado'],
        },
      ],
    },
    sectors: {
      title: 'Sectores de Experiencia',
      subtitle: 'Amplia experiencia en sectores regulados y de alta competencia',
    },
    process: {
      title: 'Cómo Trabajamos',
      subtitle: 'Un proceso transparente y orientado a resultados',
      steps: [
        { number: '01', title: 'Contacto', description: 'Llámanos y cuéntanos tu necesidad. Analizamos tu mercado y te damos respuesta rápida.' },
        { number: '02', title: 'Auditoría', description: 'Análisis completo de tu cuenta Google Ads, sitio web y oportunidades de mejora.' },
        { number: '03', title: 'Implementación', description: 'Configuramos campañas, tracking y landing pages optimizadas para conversión.' },
        { number: '04', title: 'Optimización', description: 'Mejora continua basada en datos con reporting transparente y ROI medible.' },
      ],
    },
    founder: {
      title: 'Sobre el Fundador',
      name: 'Ulysse Berneau',
      role: 'Fundador & Experto Google Ads',
      location: 'Barcelona, España',
      bio: 'Emprendedor francés especializado en marketing digital y Google Ads desde 2022. Con más de 6 millones de euros gestionados en campañas publicitarias, ayudo a empresas a escalar su captación de clientes de forma rentable y compliant.',
      expertise: ['Google Ads Certified', 'Lead Generation', 'Compliance Expert'],
      linkedin: 'https://www.linkedin.com/in/ulysseberneau/',
    },
    trust: {
      title: 'Por Qué Confiar en Nosotros',
      items: [
        { title: 'Resultados Probados', description: 'Más de 6 millones € gestionados y 1.5 millones de llamadas generadas desde 2022.' },
        { title: 'ROI Superior a 1.7', description: 'Conseguimos un retorno de inversión superior a 1.7 de media para nuestros clientes.' },
        { title: 'Sin Compromiso', description: 'Auditoría gratuita y sin compromiso. Disponibilidad inmediata para empezar.' },
      ],
    },
    callback: {
      title: '¡Un experto Google Ads te llama hoy mismo!',
      subtitle: 'Aprovecha una auditoría personalizada gratuita para tus campañas Google Ads.',
      features: ['Disponibilidad Inmediata', 'Sin Compromiso', 'Contacto Directo'],
      button: 'Llamar ahora',
    },
    cta: {
      title: 'Presupuesto rápido por teléfono',
      subtitle: 'Llámanos y cuéntanos tu necesidad en marketing digital. Te damos respuesta tras estudiar tu mercado.',
      button: 'Solicitar ahora',
    },
    form: {
      title: 'Contacto',
      subtitle: 'Cuéntanos sobre tu proyecto',
      fields: {
        name: 'Nombre y apellidos',
        company: 'Empresa',
        email: 'Email',
        phone: 'Teléfono',
        website: 'Sitio web (opcional)',
        message: 'Mensaje',
      },
      submit: 'Enviar por WhatsApp',
      whatsappMessage: 'Hola Ulysse, soy {name} de {company}. Mi web es: {website}. Necesito ayuda con: {message}. Mi teléfono es: {phone}.',
    },
    footer: {
      description: 'Agencia de marketing digital especializada en Google Ads, generación de leads y compliance publicitario. Barcelona, España.',
      legal: 'Aviso Legal',
      privacy: 'Política de Privacidad',
      cookies: 'Política de Cookies',
      location: 'Barcelona, España',
      copyright: '© 2025 Agencia PPC. Todos los derechos reservados.',
    },
    seo: {
      title: 'Agencia PPC - Agencia de Marketing Digital Google Ads | Barcelona',
      description: 'Agencia de marketing digital especializada en Google Ads, generación de leads y compliance. +6M€ gestionados, ROI >1.7. Auditoría gratuita.',
      keywords: 'agencia google ads, marketing digital, generación de leads, PPC, SEM, compliance google ads, barcelona',
    },
  },
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      compliance: 'Conformité Google Ads',
      webCreation: 'Création de Site',
      contact: 'Contact',
    },
    hero: {
      badge: 'Agence de Marketing Digital Google Ads',
      title: 'Nous sommes une agence digitale spécialisée en Google Ads',
      subtitle: 'Nous sommes une agence de marketing digital spécialisée en Google Ads et génération de leads. Campagnes optimisées, suivi des conversions et conformité pour maximiser votre ROI.',
      cta: 'Demander un audit gratuit',
      ctaCompliance: 'Compte Google Ads suspendu ?',
      ctaSecondary: 'WhatsApp',
      ctaCall: 'Appeler',
    },
    kpis: {
      title: 'Résultats depuis 2022',
      spent: { value: '6M€', label: 'dépensés sur Google Ads' },
      calls: { value: '1.5M', label: "appels entrants générés" },
      roi: { value: '>1.7', label: 'ROI moyen' },
      since: { value: '2022', label: "années d'expérience" },
    },
    mission: {
      title: 'Agence de Marketing Digital Spécialisée en Google Ads',
      text: "Nous aidons les entreprises à générer plus de clients grâce à des campagnes Google Ads optimisées, des landing pages à haute conversion et un tracking impeccable. De la stratégie à l'exécution, nous maximisons votre retour sur investissement.",
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Solutions complètes de marketing digital pour développer votre business',
      items: [
        {
          id: 'campaigns',
          title: 'Création et Optimisation de Campagnes',
          description: 'Campagnes Google Ads sur mesure pour votre business: Search, Display, Performance Max, Demand Gen et remarketing avancé.',
          features: ['Campagnes Search & Display', 'Performance Max', "Stratégies d'enchères avancées", 'Optimisation continue'],
        },
        {
          id: 'leads',
          title: 'Génération et Vente de Leads',
          description: 'Nous captons des leads qualifiés pour votre entreprise: formulaires, appels entrants et conversions mesurables.',
          features: ['Formulaires optimisés', 'Call Ads et appels entrants', 'Leads qualifiés', 'Paiement au résultat'],
        },
        {
          id: 'compliance',
          title: 'Conformité Google Ads',
          description: 'Experts en déblocage de comptes suspendus et appels: Business Operations Verification (BOV), Unacceptable Business Practices et plus.',
          features: ['Déblocage de comptes', 'Appels BOV', 'Unacceptable Business Practices', "Vérification d'annonceur"],
        },
        {
          id: 'web',
          title: 'Création de Sites Web',
          description: 'Design et développement de landing pages et sites web optimisés pour la conversion, rapides et mobile-first.',
          features: ['Landing pages haute conversion', 'Design responsive', 'Optimisation vitesse', 'UX orientée conversion'],
        },
        {
          id: 'tracking',
          title: 'Tracking et Implémentation Conversions',
          description: 'Configuration complète de Google Tag Manager, suivi des conversions, analytics et reporting détaillé.',
          features: ['Google Tag Manager', 'Tracking conversions', 'Google Analytics 4', 'Reporting personnalisé'],
        },
      ],
    },
    sectors: {
      title: "Secteurs d'Expérience",
      subtitle: 'Large expérience dans les secteurs réglementés et très concurrentiels',
    },
    process: {
      title: 'Notre Processus',
      subtitle: 'Un processus transparent et orienté résultats',
      steps: [
        { number: '01', title: 'Contact', description: 'Appelez-nous et expliquez votre besoin. Nous analysons votre marché et vous répondons rapidement.' },
        { number: '02', title: 'Audit', description: "Analyse complète de votre compte Google Ads, site web et opportunités d'amélioration." },
        { number: '03', title: 'Implémentation', description: 'Nous configurons campagnes, tracking et landing pages optimisées pour la conversion.' },
        { number: '04', title: 'Optimisation', description: 'Amélioration continue basée sur les données avec reporting transparent et ROI mesurable.' },
      ],
    },
    founder: {
      title: 'À Propos du Fondateur',
      name: 'Ulysse Berneau',
      role: 'Fondateur & Expert Google Ads',
      location: 'Barcelone, Espagne',
      bio: "Entrepreneur français spécialisé en marketing digital et Google Ads depuis 2022. Avec plus de 6 millions d'euros gérés en campagnes publicitaires, j'aide les entreprises à développer leur acquisition client de manière rentable et conforme.",
      expertise: ['Google Ads Certified', 'Génération de Leads', 'Expert Conformité'],
      linkedin: 'https://www.linkedin.com/in/ulysseberneau/',
    },
    trust: {
      title: 'Pourquoi Nous Faire Confiance',
      items: [
        { title: 'Résultats Prouvés', description: "Plus de 6 millions € gérés et 1.5 million d'appels générés depuis 2022." },
        { title: 'ROI Supérieur à 1.7', description: 'Nous obtenons un retour sur investissement supérieur à 1.7 en moyenne.' },
        { title: 'Sans Engagement', description: 'Audit gratuit et sans engagement. Disponibilité immédiate pour commencer.' },
      ],
    },
    callback: {
      title: "Un expert Google Ads vous rappelle dès aujourd'hui !",
      subtitle: 'Profitez d\'un audit personnalisé gratuit pour vos campagnes Google Ads.',
      features: ['Disponibilité Immédiate', 'Sans Engagement', 'Contact Direct'],
      button: 'Appeler maintenant',
    },
    cta: {
      title: 'Devis rapide par téléphone',
      subtitle: 'Appelez-nous et expliquez votre besoin en marketing digital. Nous vous répondons après étude de votre marché.',
      button: 'Demander maintenant',
    },
    form: {
      title: 'Contact',
      subtitle: 'Parlez-nous de votre projet',
      fields: {
        name: 'Nom et prénom',
        company: 'Entreprise',
        email: 'Email',
        phone: 'Téléphone',
        website: 'Site web (optionnel)',
        message: 'Message',
      },
      submit: 'Envoyer via WhatsApp',
      whatsappMessage: "Bonjour Ulysse, je suis {name} de {company}. Mon site est: {website}. J'ai besoin d'aide pour: {message}. Mon téléphone est: {phone}.",
    },
    footer: {
      description: 'Agence de marketing digital spécialisée en Google Ads, génération de leads et conformité publicitaire. Barcelone, Espagne.',
      legal: 'Mentions Légales',
      privacy: 'Politique de Confidentialité',
      cookies: 'Politique de Cookies',
      location: 'Barcelone, Espagne',
      copyright: '© 2025 Agencia PPC. Tous droits réservés.',
    },
    seo: {
      title: 'Agencia PPC - Agence de Marketing Digital Google Ads | Barcelone',
      description: 'Agence de marketing digital spécialisée en Google Ads, génération de leads et conformité. +6M€ gérés, ROI >1.7. Audit gratuit.',
      keywords: 'agence google ads, marketing digital, génération de leads, PPC, SEM, conformité google ads, barcelone',
    },
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      compliance: 'Google Ads Compliance',
      webCreation: 'Website Creation',
      contact: 'Contact',
    },
    hero: {
      badge: 'Google Ads Digital Marketing Agency',
      title: 'We are a digital agency specialized in Google Ads',
      subtitle: 'We are a digital marketing agency specialized in Google Ads and lead generation. Optimized campaigns, conversion tracking, and compliance to maximize your ROI.',
      cta: 'Request Free Audit',
      ctaCompliance: 'Google Ads Account Suspended?',
      ctaSecondary: 'WhatsApp',
      ctaCall: 'Call',
    },
    kpis: {
      title: 'Results Since 2022',
      spent: { value: '6M€', label: 'spent on Google Ads' },
      calls: { value: '1.5M', label: 'incoming calls generated' },
      roi: { value: '>1.7', label: 'average ROI' },
      since: { value: '2022', label: 'years of experience' },
    },
    mission: {
      title: 'Digital Marketing Agency Specialized in Google Ads',
      text: 'We help businesses generate more clients through optimized Google Ads campaigns, high-converting landing pages, and flawless tracking. From strategy to execution, we maximize your return on investment.',
    },
    services: {
      title: 'Our Services',
      subtitle: 'Complete digital marketing solutions to grow your business',
      items: [
        {
          id: 'campaigns',
          title: 'Campaign Creation and Optimization',
          description: 'Custom Google Ads campaigns for your business: Search, Display, Performance Max, Demand Gen, and advanced remarketing.',
          features: ['Search & Display Campaigns', 'Performance Max', 'Advanced Bid Strategies', 'Continuous Optimization'],
        },
        {
          id: 'leads',
          title: 'Lead Generation and Sales',
          description: 'We capture qualified leads for your business: forms, incoming calls, and measurable conversions.',
          features: ['Optimized Forms', 'Call Ads & Incoming Calls', 'Qualified Leads', 'Pay Per Result'],
        },
        {
          id: 'compliance',
          title: 'Google Ads Compliance',
          description: 'Experts in unlocking suspended accounts and filing appeals: Business Operations Verification (BOV), Unacceptable Business Practices, and more.',
          features: ['Account Unlocking', 'BOV Appeals', 'Unacceptable Business Practices', 'Advertiser Verification'],
        },
        {
          id: 'web',
          title: 'Website Creation',
          description: 'Design and development of landing pages and websites optimized for conversion, fast and mobile-first.',
          features: ['High-Converting Landing Pages', 'Responsive Design', 'Speed Optimization', 'Conversion-Focused UX'],
        },
        {
          id: 'tracking',
          title: 'Tracking & Conversion Implementation',
          description: 'Complete Google Tag Manager setup, conversion tracking, analytics, and detailed reporting.',
          features: ['Google Tag Manager', 'Conversion Tracking', 'Google Analytics 4', 'Custom Reporting'],
        },
      ],
    },
    sectors: {
      title: 'Industry Experience',
      subtitle: 'Extensive experience in regulated and highly competitive sectors',
    },
    process: {
      title: 'How We Work',
      subtitle: 'A transparent and results-oriented process',
      steps: [
        { number: '01', title: 'Contact', description: 'Call us and tell us your needs. We analyze your market and respond quickly.' },
        { number: '02', title: 'Audit', description: 'Complete analysis of your Google Ads account, website, and improvement opportunities.' },
        { number: '03', title: 'Implementation', description: 'We set up campaigns, tracking, and landing pages optimized for conversion.' },
        { number: '04', title: 'Optimization', description: 'Continuous improvement based on data with transparent reporting and measurable ROI.' },
      ],
    },
    founder: {
      title: 'About the Founder',
      name: 'Ulysse Berneau',
      role: 'Founder & Google Ads Expert',
      location: 'Barcelona, Spain',
      bio: 'French entrepreneur specialized in digital marketing and Google Ads since 2022. With over 6 million euros managed in advertising campaigns, I help businesses scale their client acquisition profitably and compliantly.',
      expertise: ['Google Ads Certified', 'Lead Generation', 'Compliance Expert'],
      linkedin: 'https://www.linkedin.com/in/ulysseberneau/',
    },
    trust: {
      title: 'Why Trust Us',
      items: [
        { title: 'Proven Results', description: 'Over 6 million € managed and 1.5 million calls generated since 2022.' },
        { title: 'ROI Above 1.7', description: 'We achieve an average return on investment above 1.7 for our clients.' },
        { title: 'No Commitment', description: 'Free audit with no commitment. Immediate availability to start.' },
      ],
    },
    callback: {
      title: 'A Google Ads expert will call you today!',
      subtitle: 'Get a free personalized audit for your Google Ads campaigns.',
      features: ['Immediate Availability', 'No Commitment', 'Direct Contact'],
      button: 'Call now',
    },
    cta: {
      title: 'Quick Quote by Phone',
      subtitle: 'Call us and tell us about your digital marketing needs. We respond after studying your market.',
      button: 'Request Now',
    },
    form: {
      title: 'Contact',
      subtitle: 'Tell us about your project',
      fields: {
        name: 'Full Name',
        company: 'Company',
        email: 'Email',
        phone: 'Phone',
        website: 'Website (optional)',
        message: 'Message',
      },
      submit: 'Send via WhatsApp',
      whatsappMessage: 'Hello Ulysse, I am {name} from {company}. My website is: {website}. I need help with: {message}. My phone is: {phone}.',
    },
    footer: {
      description: 'Digital marketing agency specialized in Google Ads, lead generation, and advertising compliance. Barcelona, Spain.',
      legal: 'Legal Notice',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy',
      location: 'Barcelona, Spain',
      copyright: '© 2025 Agencia PPC. All rights reserved.',
    },
    seo: {
      title: 'Agencia PPC - Google Ads Digital Marketing Agency | Barcelona',
      description: 'Digital marketing agency specialized in Google Ads, lead generation, and compliance. +6M€ managed, ROI >1.7. Free audit.',
      keywords: 'google ads agency, digital marketing, lead generation, PPC, SEM, google ads compliance, barcelona',
    },
  },
};

export const socialLinks = {
  linkedin: 'https://www.linkedin.com/in/ulysseberneau/',
};

// Sectors data
export const sectors = {
  es: ['Energía', 'Paneles Solares', 'Bombas de Calor', 'Seguros', 'Internet'],
  fr: ['Énergie', 'Panneaux Solaires', 'Pompes à Chaleur', 'Assurances', 'Internet'],
  en: ['Energy', 'Solar Panels', 'Heat Pumps', 'Insurance', 'Internet'],
};
